import { defineStore } from "pinia";

export const useQuoteStore = defineStore("quote", {
  state: () => ({
    quoteMode: false,
    quoteSelection: "",
    editUploadedFiles: {},
    defaultSelection: {},
    defaultSelectionUploads: {}
  }),

  getters: {
    getIsQuoteMode(state) {
      return state.quoteMode;
    },
    getQuoteSelection(state) {
      return state.quoteSelection;
    },
    getEditUploadedFiles(state) {
      return state.editUploadedFiles;
    },
    getEditUploadedFilesForPP(state) {
      return function (pp) {
        for (const i in state.editUploadedFiles) {
          if (i.code == pp) {
            return i;
          }
        }
        return null;
      };
    },
    getInitialPreflightCheckData(state) {
      const data = {};
      for (const pp in state.defaultSelectionUploads) {
        if (
          state.defaultSelectionUploads[pp].file_info &&
          state.defaultSelectionUploads[pp].file_info.preflight
        ) {
          const ppData = {};
          const preflightData =
            state.defaultSelectionUploads[pp].file_info.preflight;
          for (const preItem in preflightData) {
            if (typeof preflightData[preItem] != "object") {
              ppData[preItem] = preflightData[preItem];
            }
          }

          if (Object.keys(ppData).length > 0) {
            data[pp] = ppData;
          }
        }
      }

      if (Object.keys(data).length > 0) {
        return { preflight_values: data };
      }
      return {};
    },
    getDefaultSelectionUploads(state) {
      return state.defaultSelectionUploads;
    },
    getDefaultSelectionUploadsPP(state) {
      return function (pp) {
        if (state.defaultSelectionUploads.hasOwnProperty(pp)) {
          return state.defaultSelectionUploads[pp];
        }
        return null;
      };
    }
  },

  actions: {
    setQuoteSelection(payload) {
      this.quoteSelection = payload;
    },
    setIsQuoteMode(payload) {
      this.quoteMode = payload;
    },
    setEditUploadedFiles(payload) {
      this.editUploadedFiles = payload;
    },
    setDefaultSelectionUploads(payload) {
      this.defaultSelectionUploads = {
        ...this.defaultSelectionUploads,
        [payload.pp]: { ...payload.file }
      };
    },
    removeDefaultSelectionUploads(payload) {
      let defaultSelectionUploads = {
        ...this.defaultSelectionUploads
      };
      if (defaultSelectionUploads.hasOwnProperty(payload)) {
        delete defaultSelectionUploads[payload];
      }
      this.defaultSelectionUploads = defaultSelectionUploads;
    }
  }
});
